import type {ActivityVersion} from "./activity-library";

export const ATTENUATION_P4_PROMPT =
  "Le tableau reprend automatiquement les valeurs mesurées dans le carnet géométrie. Compléter uniquement d (m) et le produit d × Umax (V·m) pour chaque ligne. Puis comparer les produits, étudier l’effet d’un doublement de distance et conclure sur la dépendance de Umax avec d. Peut-on déduire directement une intensité en W·m⁻² de la tension mesurée ? Justifier dans la zone d’analyse.";

export const ATTENUATION_P6_PROMPT =
  "Le tableau reprend automatiquement les mesures du carnet matériaux à 200 Hz. Les colonnes fréquence, matériau, L₀ et L sont déjà remplies. Compléter uniquement l’atténuation A = L₀ − L (dB) pour chaque matériau, puis détailler un calcul et interpréter les résultats dans la zone d’analyse.";

function isAttenuationActivity(version: ActivityVersion) {
  const blocks = version.package?.interactive.blocks ?? [];
  const ids = new Set(blocks.map((block) => block.id));
  const assets = version.package?.interactive.assets ?? [];
  return (
    ids.has("P4") &&
    ids.has("P6") &&
    ids.has("P7") &&
    assets.some((asset) => asset.resourceId === "sound-geometric-attenuation") &&
    assets.some((asset) => asset.resourceId === "acoustic-material-attenuation")
  );
}

export function withCurrentAttenuationRuntimeBlocks(version: ActivityVersion): ActivityVersion {
  if (!version.package || !isAttenuationActivity(version)) return version;
  const packageClone = structuredClone(version.package);
  const ids = new Set(packageClone.interactive.blocks.map((block) => block.id));

  const p4 = packageClone.interactive.blocks.find((block) => block.id === "P4");
  if (p4?.type === "question" && ids.has("carnet-geometrie")) {
    p4.resourceMeasurementTable = true;
    p4.measurementTableKind = "bank";
    p4.measurementSourceBlockId = "carnet-geometrie";
    p4.prompt = ATTENUATION_P4_PROMPT;
  }

  const p6 = packageClone.interactive.blocks.find((block) => block.id === "P6");
  if (p6?.type === "question" && ids.has("carnet-materiaux")) {
    p6.resourceMeasurementTable = true;
    p6.measurementTableKind = "materials";
    p6.measurementSourceBlockId = "carnet-materiaux";
    p6.prompt = ATTENUATION_P6_PROMPT;
  }

  const p7 = packageClone.interactive.blocks.find((block) => block.id === "P7");
  if (p7?.type === "question") p7.answerType = "open";

  return {...version, package: packageClone};
}
